"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const fs_1 = require("fs");
const api_1 = require("@sfz-tools/core/dist/api");
const utils_1 = require("@sfz-tools/core/dist/utils");
class FileLoader {
    constructor() {
        this.files = {};
        this.filesTree = {};
        this.root = '';
        if (window.AudioContext) {
            this.audio = new window.AudioContext();
        }
    }
    addDirectory(files) {
        files.forEach((file) => this.addFile(file));
    }
    addFile(file) {
        const path = decodeURI(typeof file === 'string' ? file : file.webkitRelativePath);
        if (path === this.root)
            return;
        const fileKey = (0, utils_1.pathGetSubDirectory)(path, this.root);
        if (typeof file === 'string') {
            this.files[fileKey] = {
                ext: (0, utils_1.pathGetExt)(file),
                contents: null,
                path,
            };
        }
        else {
            this.files[fileKey] = {
                ext: (0, utils_1.pathGetExt)(file.webkitRelativePath),
                contents: null,
                path,
                handle: file,
            };
        }
        this.addToFileTree(fileKey);
        return this.files[fileKey];
    }
    addFileContents(file, contents) {
        const path = decodeURI(file);
        const fileKey = (0, utils_1.pathGetSubDirectory)(path, this.root);
        this.files[fileKey] = {
            ext: (0, utils_1.pathGetExt)(path),
            contents,
            path,
        };
        return this.files[fileKey];
    }
    addFilesContents(directory, filenames) {
        filenames.forEach((filename) => {
            this.addFileContents(directory + filename, (0, fs_1.readFileSync)(directory + filename).toString());
        });
    }
    addToFileTree(key) {
        key.split('/').reduce((o, k) => (o[k] = o[k] || {}), this.filesTree);
    }
    loadFileLocal(file, buffer = false) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!file.handle)
                return file;
            if (buffer === true) {
                const arrayBuffer = yield file.handle.arrayBuffer();
                if (this.audio && arrayBuffer) {
                    file.contents = yield this.audio.decodeAudioData(arrayBuffer);
                }
            }
            else {
                file.contents = yield file.handle.text();
            }
            return file;
        });
    }
    loadFileRemote(file, buffer = false) {
        return __awaiter(this, void 0, void 0, function* () {
            if (buffer === true) {
                const arrayBuffer = yield (0, api_1.apiArrayBuffer)((0, utils_1.encodeHashes)(file.path));
                if (this.audio) {
                    file.contents = yield this.audio.decodeAudioData(arrayBuffer);
                }
            }
            else {
                file.contents = yield (0, api_1.apiText)((0, utils_1.encodeHashes)(file.path));
            }
            return file;
        });
    }
    getFile(file, buffer = false) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!file)
                return;
            if (typeof file === 'string') {
                if ((0, utils_1.pathGetExt)(file).length === 0)
                    return;
                const fileKey = (0, utils_1.pathGetSubDirectory)(file, this.root);
                let fileRef = this.files[fileKey];
                if (!fileRef)
                    fileRef = this.addFile(file);
                if (fileRef === null || fileRef === void 0 ? void 0 : fileRef.contents)
                    return fileRef;
                if (file.startsWith('http'))
                    return yield this.loadFileRemote(fileRef, buffer);
                return yield this.loadFileLocal(fileRef, buffer);
            }
            if (file.contents)
                return file;
            if ('handle' in file)
                return yield this.loadFileLocal(file, buffer);
            return yield this.loadFileRemote(file, buffer);
        });
    }
    setRoot(dir) {
        this.root = dir;
    }
    resetFiles() {
        this.files = {};
        this.filesTree = {};
    }
}
exports.default = FileLoader;
